module.exports = __webpack_public_path__ + "static/assets/qr_home.4ebaa049.png";